<template>
  <modal
    class="auction-how-to-modal"
    name="auction-how-to-modal"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="70%"
    height="80%"
    style="z-index: 4066;"
  >
    <div id="modal-header">

      <div class="w-75 d-flex">
        <p>Ինչպե՞ս մասնակցել աճուրդին</p>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 25%"
              @click="$modal.hide('auction-how-to-modal')" aria-label="Close">
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ABAEB8"/>
        </svg>
      </button>
    </div>
    <div id="modal-body">
      <div class="detail-content">
        <div class="row h-100 mx-0">
          <div class="col-12">
            <div class="auction-guide">
              <h1>Ինչպե՞ս մասնակցել աճուրդին</h1>

              <p>
                Բաց աճուրդը iTender մրցույթներում հաղթողին որոշելու եղանակ է, որի ընթացքում
                բավարար գնահատված մասնակիցները հնարավորություն ունեն բարելավել իրենց ներկայացրած գները։
              </p>

              <h2>1. Սպասեք աճուրդի մեկնարկին</h2>

              <p>Եթե աճուրդը դեռ չի մեկնարկել, քարտի վրա կտեսնեք՝</p>

              <p>🟡 <strong>Սկսվելու է</strong></p>

              <p>
                Այդ փուլում գին առաջարկելու հնարավորությունը դեռ ակտիվ չէ։
                Գին ներկայացնել հնարավոր կլինի միայն աճուրդի մեկնարկից հետո։
              </p>

              <h3>2. Ծանոթացեք աճուրդի տեղեկատվությանը</h3>

              <p>Աճուրդի ընթացքում քարտի վրա կտեսնեք՝</p>

              <ul>
                <li>📉 Ընթացիկ նվազագույն գին</li>
                <li>💰 Ձեր առաջարկը</li>
                <li>⏱ Մինչև ավարտը մնացած ժամանակը</li>
                <li>📊 Նվազագույն քայլը</li>
                <li>Տվյալ չափաբաժնի քանակը</li>
                <li>
                  Միավորի գինը՝ ընթացիկ նվազագույն գնի, Ձեր առաջարկի և նոր ներկայացվող գնի համար
                </li>
              </ul>

              <p>
                Այս տվյալները թույլ են տալիս արագ հասկանալ աճուրդի ընթացքը և որոշել՝
                արդյոք ցանկանում եք բարելավել Ձեր առաջարկը։
              </p>

              <h3>3. Ներկայացրեք նոր գին</h3>

              <p>
                Եթե ցանկանում եք բարելավել Ձեր առաջարկը, օգտագործեք նվազեցնելու կոճակը։
              </p>

              <p>
                Նոր գինը պետք է լինի ընթացիկ նվազագույն գնից առնվազն սահմանված քայլով ցածր։
              </p>

              <p>
                Օրինակ՝ եթե ընթացիկ նվազագույն գինը 100,000 դրամ է, իսկ նվազագույն քայլը՝ 2%,
                ապա նոր առաջարկը պետք է լինի առնվազն 2%-ով ցածր։
              </p>

              <h3>4. Հաստատեք առաջարկը</h3>

              <p>Նոր գինը ընտրելուց հետո սեղմեք՝</p>

              <p>🔨 <strong>Առաջարկել</strong></p>

              <p>կոճակը։</p>

              <p>
                Հաջող հաստատման դեպքում համակարգն անմիջապես կթարմացնի տվյալները։
              </p>

              <h3>5. Հետևեք արդյունքներին</h3>

              <p>
                Եթե Ձեր գինը տվյալ պահին ամենացածրն է, «Իմ առաջարկը» հատվածը կնշվի
                կանաչ գույնով։
              </p>

              <p>
                Եթե այլ մասնակից ներկայացնի ավելի ցածր գին, համակարգը անմիջապես
                կթարմացնի ընթացիկ նվազագույն գինը և Ձեր առաջարկի կարգավիճակը։
              </p>

              <h3>6. Զգուշացում</h3>

              <p>
                Եթե Ձեր առաջարկը նախահաշվային արժեքից ցածր է ավելի քան 25%-ով,
                համակարգը կցուցադրի զգուշացում։
              </p>

              <p>
                Խնդրում ենք համոզվել, որ ներկայացվող գինը ճիշտ է հաշվարկված։
              </p>

              <p>
                Զգուշացումը չի արգելափակում առաջարկի ներկայացումը, սակայն օգնում է
                խուսափել սխալ կամ պատահական ցածր գին ներկայացնելուց։
              </p>

              <h3>7. Աճուրդի ավարտ</h3>

              <p>
                Աճուրդի համար նախատեսված ժամանակի ավարտից հետո սկսվում է արդյունքների
                ամփոփման գործընթացը, որը հաստատվում է կազմակերպչի կողմից։
              </p>

              <p>
                Հաղթող է ճանաչվում այն մասնակիցը, որի վերջնական առաջարկը համեմատության
                կանոններով ամենացածրն է, եթե կազմակերպչի գնահատմամբ նվազագույն գինը
                համարվում է ողջամիտ։
              </p>

              <h3>8. Պատասխանատվություն անիրական գին ներկայացնելու դեպքում</h3>

              <p>
                Աճուրդի ընթացքում ներկայացված գինը համարվում է մասնակցի կողմից
                հաստատված առաջարկ։
              </p>

              <p>
                Եթե մասնակիցը միտումնավոր ներկայացնում է ակնհայտ անիրական կամ չափազանց
                ցածր գին, իսկ հետո հրաժարվում է այդ գնով պայմանագիր կնքելուց կամ
                պարտավորությունը կատարելուց, այդ վարքագիծը կարող է դիտարկվել որպես
                անբարեխիղճ մասնակցություն։
              </p>

              <p>
                Այդպիսի դեպքերում համակարգի Օպերատորը կարող է սահմանափակել կամ
                արգելափակել տվյալ կազմակերպության մասնակցությունը iTender մրցույթներին։
              </p>

              <h3>Կարևոր է իմանալ</h3>

              <ul>
                <li>Մասնակիցների անվանումները աճուրդի ընթացքում չեն ցուցադրվում։</li>
                <li>Մասնակիցների քանակը չի ցուցադրվում։</li>
                <li>Դիրքեր՝ 1-ին, 2-րդ, 3-րդ, չեն ցուցադրվում։</li>
                <li>Ցուցադրվում է միայն ընթացիկ նվազագույն գինը։</li>
                <li>
                  Մասնակիցը տեսնում է միայն իր առաջարկը և աճուրդի ընթացիկ նվազագույն գինը։
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<style>
.detail-content {
  max-width: 900px;
  margin: 20px auto;
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
</style>
<script>
export default {
  name: 'AuctionHowToModal',
}
</script>


<style scoped>
.regulations-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

.regulations-content {
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

h1 {
  text-align: center;
  color: #2c3e50;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 3px solid #3498db;
}

h2 {
  color: #2c3e50;
  font-size: 22px;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
}

h3 {
  color: #34495e;
  font-size: 18px;
  font-weight: bold;
  margin-top: 25px;
  margin-bottom: 15px;
}

p {
  margin-bottom: 15px;
  font-size: 14px;
  text-align: justify;
}

strong {
  font-weight: bold;
  color: #2c3e50;
}

ul {
  margin: 15px 0;
  padding-left: 30px;
}

ul li {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.6;
}

/* Responsive design */
@media (max-width: 768px) {
  .regulations-content {
    padding: 20px;
  }

  h1 {
    font-size: 24px;
  }

  h2 {
    font-size: 20px;
  }

  h3 {
    font-size: 16px;
  }

  p, ul li {
    font-size: 13px;
  }
}

/* Print styles */
@media print {
  .regulations-container {
    max-width: 100%;
    padding: 0;
  }

  .regulations-content {
    box-shadow: none;
    padding: 20px;
  }
}
</style>
